import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import WhatsAppRedirect from "./pages/WhatsAppRedirect";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Contact from "./pages/Contact";
import About from "./pages/About";
import { AstrologersProvider } from "./context/AstrologersContext";
import { AdminProvider } from "./context/AdminContext";
import { Toaster } from "./components/ui/toaster";

function App() {
  return (
    <div className="App">
      <AdminProvider>
        <AstrologersProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/go/whatsapp/:astroId" element={<WhatsAppRedirect />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/about" element={<About />} />
            </Routes>
            <Toaster />
          </BrowserRouter>
        </AstrologersProvider>
      </AdminProvider>
    </div>
  );
}

export default App;
